@if (translation?.code) {
  <div class="modal-header d-flex justify-content-between align-items-center">
    <span class="modal-title">
      <h4 class="card-title text-white">Créer ou éditer une traduction ({{ lang }})</h4>
    </span>
    <button type="button" class="btn-close" data-dismiss="modal" aria-hidden="true" (click)="cancel()"></button>
  </div>

  <div class="modal-body">
    <form name="editForm" role="form" novalidate #editForm="ngForm">
      <div class="row blc-blanc row-cols-sm-1 row-cols-md-1">
        <div class="row col mb-3">
          <div class="col-sm-3 col-form-label">Code</div>
          <div class="col-sm-9">
            <input class="form-control input-st" type="text" name="code" id="field_code" [value]="translation.code" disabled />
          </div>
        </div>
        <div class="row col mb-3">
          <div class="col-sm-3 col-form-label">Libelle ({{ lang }})</div>
          <div class="col-sm-9">
            @if (lang === 'ar') {
              <tmw-input-ar name="label" id="field_label" [(ngModel)]="translation.libelle" required></tmw-input-ar>
            } @else {
              <input type="text" class="form-control input-st" name="label" id="field_label" [(ngModel)]="translation.libelle" required />
            }
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="cancel()">
      <i class="bi bi-arrow-bar-left"></i>&nbsp;<span tmwTranslate="entity.action.close">Fermer</span>
    </button>
    <button
      *hasAnyAccess="'SAVE_TRANSLATION'; module: 'MDL_GENERAL'"
      type="button"
      id="save-entity"
      [disabled]="editForm.invalid || isSaving"
      class="btn btn-primary"
      (click)="save()"
    >
      <i class="bi bi-save"></i>&nbsp;<span tmwTranslate="entity.action.save">Sauvegarder</span>
    </button>
  </div>
}
